<div #map class="map" [id]="id"></div>